import { render, staticRenderFns } from "./scope36.vue?vue&type=template&id=1a0507ba&scoped=true"
import script from "./scope36.vue?vue&type=script&lang=js"
export * from "./scope36.vue?vue&type=script&lang=js"
import style0 from "./scope36.vue?vue&type=style&index=0&id=1a0507ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0507ba",
  null
  
)

export default component.exports